import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { COLA_STATUS, FIELD } from './colaEnums';
import { getClient, getClientApplication, getClientLatestLoanPayment, getDiscounts, getLatestLoan, getClientLatestLoanPaymentZp } from './requests';

var getBestDiscount = function getBestDiscount(discounts) {
  discounts.sort(function (a, b) {
    if (a.discountPercent < b.discountPercent) {
      return 1;
    } else if (a.discountPercent > b.discountPercent) {
      return -1;
    }

    return 0;
  }).filter(function (discount) {
    var currentDate = new Date();
    var discountStartDate = new Date(discount.validityRanges[0].min);
    var discountEndDate = new Date(discount.validityRanges[0].max);
    return discountStartDate <= currentDate && discountEndDate >= currentDate;
  });
  return discounts[0];
};

var extractResolutionFromColaResponse = function extractResolutionFromColaResponse(_ref) {
  var status = _ref.status,
      clientApplication = _ref.clientApplication;
  var res = {
    status: status,
    processedField: '',
    fieldType: ''
  };

  if (clientApplication.resolution === 'APPROVED') {
    res.processedField = 'APPROVED';
  } else if (clientApplication.resolution === 'REJECTED' || clientApplication.resolution === 'MANUAL') {
    if (clientApplication.resolutionMessage) {
      res.processedField = clientApplication.resolutionMessage;
      res.fieldType = 'resolutionMessage';
    } else if (clientApplication.resolutionDetail) {
      // Exception required because 'INVALID_PERSONAL_DATA' resolution detail can be both for REJECTED and MANUAL
      if (clientApplication.resolutionDetail === 'INVALID_PERSONAL_DATA') {
        res.processedField = "INVALID_PERSONAL_DATA_".concat(clientApplication.resolution);
        res.fieldType = 'resolutionDetail';
      } else {
        res.processedField = clientApplication.resolutionDetail;
        res.fieldType = 'resolutionDetail';
      }
    } else {
      res.processedField = clientApplication.resolution;
    }
  } else if (clientApplication.resolution === 'CANCELLED') {
    res.processedField = 'CANCELLED';
  } else {
    res.processedField = 'DEFAULT';
  }

  return res;
};

export default function getColaField(_x, _x2, _x3) {
  return _getColaField.apply(this, arguments);
}

function _getColaField() {
  _getColaField = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(field, webapiUrl, headers) {
    var _ref2, status, latestLoan, _ref3, _status, _latestLoan, _ref4, _status2, _latestLoan2, _ref5, _status3, _latestLoan3, _ref6, _status4, _latestLoan4, _ref7, _status5, _latestLoan5, loanExtensionFees, loanExtFee, _ref8, _status6, _latestLoan6, colaRes, _status7, res, clientRes, _colaRes, _ref9, _status8, latestLoanPayment, _ref10, _status9, _latestLoanPayment, _ref11, _status10, client, _ref12, _status11, _latestLoan7, _ref13, _status12, _client, _ref14, _status13, discounts, bestDiscount, _ref15, _status14, _latestLoanPayment2, _ref16, _status15, _latestLoanPayment3, _ref17, _status16, _latestLoan8, _loanExtensionFees, _loanExtFee, _ref18, _status17, _latestLoan9, _loanExtensionFees2, _loanExtFee2;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = field;
            _context.next = _context.t0 === FIELD.NEXT_PAYMENT_DATE ? 3 : _context.t0 === FIELD.DUE_DATE ? 15 : _context.t0 === FIELD.NEXT_PAYMENT_AMOUNT ? 27 : _context.t0 === FIELD.PAY_NOW_AMOUNT ? 39 : _context.t0 === FIELD.PENALTY_AMOUNT ? 51 : _context.t0 === FIELD.EXTENSION_AMOUNT_7 ? 63 : _context.t0 === FIELD.OVERDUE_DAYS ? 78 : _context.t0 === FIELD.CLIENT_APP_RESOLUTION_MESSAGE ? 90 : _context.t0 === FIELD.APP_CREDIT_LIMIT ? 100 : _context.t0 === FIELD.LATEST_PAYMENT_DATE_ZP ? 116 : _context.t0 === FIELD.LATEST_PAYMENT_DATE ? 128 : _context.t0 === FIELD.CLIENT_NUMBER ? 140 : _context.t0 === FIELD.LOAN_NUMBER ? 152 : _context.t0 === FIELD.BANK_ACCOUNT ? 164 : _context.t0 === FIELD.DISCOUNT_TYPE ? 176 : _context.t0 === FIELD.LATEST_PAYMENT_AMOUNT_ZP ? 191 : _context.t0 === FIELD.LATEST_PAYMENT_AMOUNT ? 203 : _context.t0 === FIELD.EXTENSION_AMOUNT_14 ? 215 : _context.t0 === FIELD.EXTENSION_AMOUNT_30 ? 231 : 247;
            break;

          case 3:
            _context.next = 5;
            return getLatestLoan(webapiUrl, headers);

          case 5:
            _ref2 = _context.sent;
            status = _ref2.status;
            latestLoan = _ref2.latestLoan;

            if (!(status === COLA_STATUS.OK)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", {
              status: status,
              processedField: latestLoan.nearestPaymentDate
            });

          case 12:
            if (!(status === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", {
              status: status,
              processedField: ''
            });

          case 14:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 15:
            _context.next = 17;
            return getLatestLoan(webapiUrl, headers);

          case 17:
            _ref3 = _context.sent;
            _status = _ref3.status;
            _latestLoan = _ref3.latestLoan;

            if (!(_status === COLA_STATUS.OK)) {
              _context.next = 24;
              break;
            }

            return _context.abrupt("return", {
              status: _status,
              processedField: _latestLoan.dueDate
            });

          case 24:
            if (!(_status === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 26;
              break;
            }

            return _context.abrupt("return", {
              status: _status,
              processedField: ''
            });

          case 26:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 27:
            _context.next = 29;
            return getLatestLoan(webapiUrl, headers);

          case 29:
            _ref4 = _context.sent;
            _status2 = _ref4.status;
            _latestLoan2 = _ref4.latestLoan;

            if (!(_status2 === COLA_STATUS.OK)) {
              _context.next = 36;
              break;
            }

            return _context.abrupt("return", {
              status: _status2,
              processedField: typeof _latestLoan2.payableAmount === 'number' ? _latestLoan2.payableAmount.toFixed(2) : _latestLoan2.payableAmount
            });

          case 36:
            if (!(_status2 === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 38;
              break;
            }

            return _context.abrupt("return", {
              status: _status2,
              processedField: ''
            });

          case 38:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 39:
            _context.next = 41;
            return getLatestLoan(webapiUrl, headers);

          case 41:
            _ref5 = _context.sent;
            _status3 = _ref5.status;
            _latestLoan3 = _ref5.latestLoan;

            if (!(_status3 === COLA_STATUS.OK)) {
              _context.next = 48;
              break;
            }

            return _context.abrupt("return", {
              status: _status3,
              processedField: typeof _latestLoan3.payNowAmount === 'number' ? _latestLoan3.payNowAmount.toFixed(2) : _latestLoan3.payNowAmount
            });

          case 48:
            if (!(_status3 === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 50;
              break;
            }

            return _context.abrupt("return", {
              status: _status3,
              processedField: ''
            });

          case 50:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 51:
            _context.next = 53;
            return getLatestLoan(webapiUrl, headers);

          case 53:
            _ref6 = _context.sent;
            _status4 = _ref6.status;
            _latestLoan4 = _ref6.latestLoan;

            if (!(_status4 === COLA_STATUS.OK)) {
              _context.next = 60;
              break;
            }

            return _context.abrupt("return", {
              status: _status4,
              processedField: typeof _latestLoan4.penaltyAmount === 'number' ? _latestLoan4.penaltyAmount.toFixed(2) : _latestLoan4.penaltyAmount
            });

          case 60:
            if (!(_status4 === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 62;
              break;
            }

            return _context.abrupt("return", {
              status: _status4,
              processedField: ''
            });

          case 62:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 63:
            _context.next = 65;
            return getLatestLoan(webapiUrl, headers);

          case 65:
            _ref7 = _context.sent;
            _status5 = _ref7.status;
            _latestLoan5 = _ref7.latestLoan;

            if (!(_status5 === COLA_STATUS.OK)) {
              _context.next = 75;
              break;
            }

            loanExtensionFees = _latestLoan5.loanExtensionFees;

            if (!(loanExtensionFees.length > 0)) {
              _context.next = 73;
              break;
            }

            loanExtFee = loanExtensionFees.find(function (extension) {
              return extension.term === 7;
            });
            return _context.abrupt("return", {
              status: _status5,
              processedField: typeof loanExtFee.fee === 'number' ? loanExtFee.fee.toFixed(2) : loanExtFee.fee
            });

          case 73:
            _context.next = 77;
            break;

          case 75:
            if (!(_status5 === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 77;
              break;
            }

            return _context.abrupt("return", {
              status: _status5,
              processedField: ''
            });

          case 77:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 78:
            _context.next = 80;
            return getLatestLoan(webapiUrl, headers);

          case 80:
            _ref8 = _context.sent;
            _status6 = _ref8.status;
            _latestLoan6 = _ref8.latestLoan;

            if (!(_status6 === COLA_STATUS.OK)) {
              _context.next = 87;
              break;
            }

            return _context.abrupt("return", {
              status: _status6,
              processedField: _latestLoan6.overDueDays
            });

          case 87:
            if (!(_status6 === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 89;
              break;
            }

            return _context.abrupt("return", {
              status: _status6,
              processedField: ''
            });

          case 89:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 90:
            _context.next = 92;
            return getClientApplication(webapiUrl, headers);

          case 92:
            colaRes = _context.sent;
            _status7 = colaRes.status;
            res = {
              status: _status7,
              processedField: '',
              fieldType: ''
            };

            if (!(_status7 === COLA_STATUS.OK)) {
              _context.next = 97;
              break;
            }

            return _context.abrupt("return", extractResolutionFromColaResponse(colaRes));

          case 97:
            if (!(_status7 === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 99;
              break;
            }

            return _context.abrupt("return", res);

          case 99:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 100:
            _context.next = 102;
            return getClient(webapiUrl, headers);

          case 102:
            clientRes = _context.sent;
            _context.next = 105;
            return getLatestLoan(webapiUrl, headers);

          case 105:
            _colaRes = _context.sent;

            if (!(clientRes.status === COLA_STATUS.OK)) {
              _context.next = 113;
              break;
            }

            if (!(_colaRes.status === COLA_STATUS.OK)) {
              _context.next = 110;
              break;
            }

            if (!(_colaRes.latestLoan.overDueDays > 0)) {
              _context.next = 110;
              break;
            }

            return _context.abrupt("return", {
              status: COLA_STATUS.ADDITIONAL_UNAVAILABLE,
              processedField: 0
            });

          case 110:
            return _context.abrupt("return", {
              status: clientRes.status,
              processedField: typeof clientRes.client.creditLimit === 'number' ? clientRes.client.creditLimit.toFixed(2) : clientRes.client.creditLimit
            });

          case 113:
            if (!(clientRes.status === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 115;
              break;
            }

            return _context.abrupt("return", {
              status: clientRes.status,
              processedField: ''
            });

          case 115:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 116:
            _context.next = 118;
            return getClientLatestLoanPaymentZp(webapiUrl, headers);

          case 118:
            _ref9 = _context.sent;
            _status8 = _ref9.status;
            latestLoanPayment = _ref9.latestLoanPayment;

            if (!(_status8 === COLA_STATUS.OK)) {
              _context.next = 125;
              break;
            }

            return _context.abrupt("return", {
              status: _status8,
              processedField: latestLoanPayment.bookingDate
            });

          case 125:
            if (!(_status8 === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 127;
              break;
            }

            return _context.abrupt("return", {
              status: _status8,
              processedField: ''
            });

          case 127:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 128:
            _context.next = 130;
            return getClientLatestLoanPayment(webapiUrl, headers);

          case 130:
            _ref10 = _context.sent;
            _status9 = _ref10.status;
            _latestLoanPayment = _ref10.latestLoanPayment;

            if (!(_status9 === COLA_STATUS.OK)) {
              _context.next = 137;
              break;
            }

            return _context.abrupt("return", {
              status: _status9,
              processedField: _latestLoanPayment.bookingDate
            });

          case 137:
            if (!(_status9 === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 139;
              break;
            }

            return _context.abrupt("return", {
              status: _status9,
              processedField: ''
            });

          case 139:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 140:
            _context.next = 142;
            return getClient(webapiUrl, headers);

          case 142:
            _ref11 = _context.sent;
            _status10 = _ref11.status;
            client = _ref11.client;

            if (!(_status10 === COLA_STATUS.OK)) {
              _context.next = 149;
              break;
            }

            return _context.abrupt("return", {
              status: _status10,
              processedField: client.number
            });

          case 149:
            if (!(_status10 === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 151;
              break;
            }

            return _context.abrupt("return", {
              status: _status10,
              processedField: ''
            });

          case 151:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 152:
            _context.next = 154;
            return getLatestLoan(webapiUrl, headers);

          case 154:
            _ref12 = _context.sent;
            _status11 = _ref12.status;
            _latestLoan7 = _ref12.latestLoan;

            if (!(_status11 === COLA_STATUS.OK)) {
              _context.next = 161;
              break;
            }

            return _context.abrupt("return", {
              status: _status11,
              processedField: _latestLoan7.loanNumber
            });

          case 161:
            if (!(_status11 === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 163;
              break;
            }

            return _context.abrupt("return", {
              status: _status11,
              processedField: ''
            });

          case 163:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 164:
            _context.next = 166;
            return getClient(webapiUrl, headers);

          case 166:
            _ref13 = _context.sent;
            _status12 = _ref13.status;
            _client = _ref13.client;

            if (!(_status12 === COLA_STATUS.OK)) {
              _context.next = 173;
              break;
            }

            return _context.abrupt("return", {
              status: _status12,
              processedField: _client.bankAccount
            });

          case 173:
            if (!(_status12 === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 175;
              break;
            }

            return _context.abrupt("return", {
              status: _status12,
              processedField: ''
            });

          case 175:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 176:
            _context.next = 178;
            return getDiscounts(webapiUrl, headers);

          case 178:
            _ref14 = _context.sent;
            _status13 = _ref14.status;
            discounts = _ref14.discounts;

            if (!(_status13 === COLA_STATUS.OK)) {
              _context.next = 188;
              break;
            }

            if (!discounts.availableDiscounts.length) {
              _context.next = 185;
              break;
            }

            bestDiscount = getBestDiscount(discounts.availableDiscounts);
            return _context.abrupt("return", {
              status: _status13,
              processedField: bestDiscount.type,
              percentage: bestDiscount.discountPercent
            });

          case 185:
            return _context.abrupt("return", {
              status: _status13,
              processedField: ''
            });

          case 188:
            if (!(_status13 === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 190;
              break;
            }

            return _context.abrupt("return", {
              status: _status13,
              processedField: ''
            });

          case 190:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 191:
            _context.next = 193;
            return getClientLatestLoanPaymentZp(webapiUrl, headers);

          case 193:
            _ref15 = _context.sent;
            _status14 = _ref15.status;
            _latestLoanPayment2 = _ref15.latestLoanPayment;

            if (!(_status14 === COLA_STATUS.OK)) {
              _context.next = 200;
              break;
            }

            return _context.abrupt("return", {
              status: _status14,
              processedField: typeof _latestLoanPayment2.amount === 'number' ? _latestLoanPayment2.amount.toFixed(2) : _latestLoanPayment2.amount
            });

          case 200:
            if (!(_status14 === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 202;
              break;
            }

            return _context.abrupt("return", {
              status: _status14,
              processedField: ''
            });

          case 202:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 203:
            _context.next = 205;
            return getClientLatestLoanPayment(webapiUrl, headers);

          case 205:
            _ref16 = _context.sent;
            _status15 = _ref16.status;
            _latestLoanPayment3 = _ref16.latestLoanPayment;

            if (!(_status15 === COLA_STATUS.OK)) {
              _context.next = 212;
              break;
            }

            return _context.abrupt("return", {
              status: _status15,
              processedField: typeof _latestLoanPayment3.amount === 'number' ? _latestLoanPayment3.amount.toFixed(2) : _latestLoanPayment3.amount
            });

          case 212:
            if (!(_status15 === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 214;
              break;
            }

            return _context.abrupt("return", {
              status: _status15,
              processedField: ''
            });

          case 214:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 215:
            _context.next = 217;
            return getLatestLoan(webapiUrl, headers);

          case 217:
            _ref17 = _context.sent;
            _status16 = _ref17.status;
            _latestLoan8 = _ref17.latestLoan;

            if (!(_status16 === COLA_STATUS.OK)) {
              _context.next = 228;
              break;
            }

            _loanExtensionFees = _latestLoan8.loanExtensionFees;

            if (!(_loanExtensionFees.length > 0)) {
              _context.next = 226;
              break;
            }

            _loanExtFee = _loanExtensionFees.find(function (extension) {
              return extension.term === 14;
            });

            if (!_loanExtFee) {
              _context.next = 226;
              break;
            }

            return _context.abrupt("return", {
              status: _status16,
              processedField: typeof _loanExtFee.fee === 'number' ? _loanExtFee.fee.toFixed(2) : _loanExtFee.fee
            });

          case 226:
            _context.next = 230;
            break;

          case 228:
            if (!(_status16 === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 230;
              break;
            }

            return _context.abrupt("return", {
              status: _status16,
              processedField: ''
            });

          case 230:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 231:
            _context.next = 233;
            return getLatestLoan(webapiUrl, headers);

          case 233:
            _ref18 = _context.sent;
            _status17 = _ref18.status;
            _latestLoan9 = _ref18.latestLoan;

            if (!(_status17 === COLA_STATUS.OK)) {
              _context.next = 244;
              break;
            }

            _loanExtensionFees2 = _latestLoan9.loanExtensionFees;

            if (!(_loanExtensionFees2.length > 0)) {
              _context.next = 242;
              break;
            }

            _loanExtFee2 = _loanExtensionFees2.find(function (extension) {
              return extension.term === 30;
            });

            if (!_loanExtFee2) {
              _context.next = 242;
              break;
            }

            return _context.abrupt("return", {
              status: _status17,
              processedField: typeof _loanExtFee2.fee === 'number' ? _loanExtFee2.fee.toFixed(2) : _loanExtFee2.fee
            });

          case 242:
            _context.next = 246;
            break;

          case 244:
            if (!(_status17 === COLA_STATUS.UNAUTHORISED)) {
              _context.next = 246;
              break;
            }

            return _context.abrupt("return", {
              status: _status17,
              processedField: ''
            });

          case 246:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 247:
            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR,
              processedField: ''
            });

          case 248:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getColaField.apply(this, arguments);
}